module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContentHeader":{"alt":"Obrázek kategorie {category}"}}}')
  delete Component.options._Ctor
}
